import { render, staticRenderFns } from "./TabsChildC.vue?vue&type=template&id=29b4ba3a&"
import script from "./TabsChildC.vue?vue&type=script&lang=js&"
export * from "./TabsChildC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports